
import { implementSetAllNavTabDetailsMutation } from '../../../../dt-plugins/sidewindow/nav-tab';
import * as types from './types';

// Mutations Object for Product_groupsCatalog. Use it by importing product_groups/types.js and calling commit() from  product_groups/actions.js Action File.
export const product_groupsCatalogMutations = {
  [types.Product_groupsCatalogData.SET.ALL] (state, payload) {
    state.product_groupsCatalogData = payload;
  },
  [types.Product_groupsList.SET.ALL] (state, payload) {
    state.product_groupsList = payload;
  },
  ...implementSetAllNavTabDetailsMutation(types.Product_groupDetails, 'product_groupDetails'),
}